export default {
      id: "plus-rounded-usage",
      viewBox: "0 0 29 29",
      url: "/dist/svg/" + "sprite.svg#plus-rounded-usage",
      toString: function () {
        return this.url;
      }
    }